export const SET_ADMISSION = "SET_ADMISSION";
export const GET_ADMISSION = "GET_ADMISSION";
export const DELETE_ADMISSION = "DELETE_ADMISSION";